<template>
  <div>
    <!-- 门票列表 -->
    <div class="ticketDetail twBg">
      <div class="walfBox">
        <BreadCrumb :navList="[{url:'/',name:'预定中心'},{url:'/ticket',name:'门票预订'},{url:'',name:'门票列表'}]" />
        <div class="container-center">
          <div class="container-center-left">
            <p class="listTitle"><span>门票列表</span></p>
            <div class="xian"></div>
            <!-- 筛选框 -->
            <div class="container-box min_box_ra">
              <span class="right" @click="clearData()">清空筛选条件</span>
              <ul class="search-list">
                <li>
                  <span>已筛选条件：</span>
                  <ul>
                    <li class="liInline no border" v-for="item in searchList" :key="item">{{item}}</li>
                  </ul>
                </li>
                <li>
                  <span>目的地：</span>
                  <ul>
                    <li class="liInline" :class="destinationId==item.id ? 'active' :''"
                      @click="destinationId=item.id;getData()" v-for="item in destinationList" :key="item.id">
                      {{item.name}}</li>
                  </ul>
                </li>
                <!-- <li>
                                <span>景点主题：</span>
                                <ul>
                                    <li class="liInline" :class="topicIds.includes(item.id) ? 'active' :''" @click="hanbleTopicList(item);getData()" v-for="item in topicList" :key="item.id" >{{item.name}}</li>
                                </ul>
                            </li> -->
                <li>
                  <span>景点等级：</span>
                  <ul>
                    <li class="liInline" :class="level==item ? 'active' :''" @click="level=item;getData()"
                      v-for="item in levelList" :key="item">{{item}}</li>
                  </ul>
                </li>
              </ul>
            </div>
            <!-- 排序 -->
            <ul class="sort-list">
              <li>综合排序
                <!-- <span class="arrow" @click="changeSort('zhSort')">
                                <i class="el-icon-caret-top" :class="zhSort == 0 ? 'activeTop' :''"></i>
                                <i class="el-icon-caret-bottom"  :class="zhSort == 1 ? 'activeTop' :''"></i>
                            </span> -->
              </li>
              <li>价格
                <span class="arrow" @click="changeSort('priceSort')">
                  <i class="el-icon-caret-top" :class="priceSort == 0 ? 'activeTop' :''"></i>
                  <i class="el-icon-caret-bottom" :class="priceSort == 1 ? 'activeTop' :''"></i>
                </span>
              </li>
              <li>销量
                <span class="arrow" @click="changeSort('xlSort')">
                  <i class="el-icon-caret-top" :class="xlSort == 0 ? 'activeTop' :''"></i>
                  <i class="el-icon-caret-bottom" :class="xlSort == 1 ? 'activeTop' :''"></i>
                </span>
              </li>
              <!-- <li>推荐
                            <span class="arrow" @click="changeSort('tjSort')">
                                <i class="el-icon-caret-top" :class="tjSort == 0 ? 'activeTop' :''"></i>
                                <i class="el-icon-caret-bottom" :class="tjSort == 1 ? 'activeTop' :''"></i>
                            </span>
                        </li> -->
            </ul>
            <!-- 门票列表 -->
            <div class="ticket-list min_box_ra" v-for="item in dataList" :key="item.id">
              <div class="ticket-list-top" @click="goDetail(item.id,'spot')">
                <div class="ticket-list-left">
                  <img :src="item.cover" alt="">
                </div>
                <div class="ticket-list-right">
                  <div class="title">
                    <span>{{item.name}}</span>
                    <el-rate v-model="item.commentLevel" disabled show-score text-color="#ff9900"
                      score-template="{value}分">
                    </el-rate>
                  </div>
                  <div class="tip">
                    <span>{{item.soldNumber}}人已购买</span><span>{{item.commentNumber}}条评论</span>
                  </div>
                  <div class="time"><i></i>{{item.openTime}}</div>
                  <div class="address" :title="item.address"><i></i>{{item.address}}</div>
                  <div class="price" v-show="item.minPrice">￥{{item.minPrice}} <span>起</span></div>
                </div>
              </div>
              <div class="ticket-list-bottom">
                <ul>
                  <template v-for="(itm,idx) in item.ticketListVOS">
                    <li v-if="idx<3 || item.moreTicket" :key="itm.id">
                      <div class="overflow-text" style="display:inline-block;vertical-align:middle;cursor: pointer;"
                        :title="itm.name" @click="itm.detailShow=!itm.detailShow;$forceUpdate()">{{itm.name}}
                        <i :class="!itm.detailShow ? 'el-icon-arrow-right':'el-icon-arrow-up'" style="position: absolute;top: 19px;"></i></div>
                      <div class="tip">
                        <span>当天{{itm.bookLimitTime}}前可预订</span>
                        <!-- <span>{{itm.payWay == 'ONLINE' ? '线上支付' :'线下支付'}}</span> -->
                        <span v-show="itm.minPrice">￥{{itm.minPrice}}起</span>
                      </div>
                      <div class="tip-detail" v-if="itm.detailShow">
                        <div v-html="itm.detail"></div>
                      </div>
                      <div class="order" v-if="item.ticketListVOS.length>3"
                        @click="goRoute('/checkOrder?orderType=TICKET&id='+itm.id,itm)">在线预定</div>
                    </li>
                  </template>
                </ul>
                <span class="more-btn" v-if="item.ticketListVOS.length>3"
                  @click="item.moreTicket = !item.moreTicket;$forceUpdate()">{{item.moreTicket ? '关闭' :'展开'}}余下门票></span>
              </div>
            </div>
            <div class="ticket-list" v-if="dataList.length==0">
              暂无数据
            </div>
          </div>
          <div class="container-center-right">
            <p class="listTitle"><span>热卖门票</span></p>
            <div class="xian"></div>
            <ul class="min_box_ra">
              <template v-for="(item,index) in hotTicketList">
                <li v-if="index<4" :key="item.id" @click="goDetail(item.scenicSpotId,'spot')">
                  <div class="hot-left">
                    <img :src="item.cover" />
                    <span>{{index+1}}</span>
                  </div>
                  <div class="hot-right">
                    <div class="title" :title="item.name">{{item.name}}</div>
                    <div class="bottom"><span class="left">销量：{{item.soldNumber}}</span><span class="right"
                        v-show="item.minPrice">￥{{item.minPrice}}起</span></div>
                  </div>
                </li>
              </template>
            </ul>
            <p class="listTitle" style="margin-top:50px;"><span>热门景点</span></p>
            <ul class="hotSpot min_box_ra">
              <template v-for="(item,index) in hotDataList">
                <li :key="item.id" @click="goDetail(item.id,'spot')">
                  <div class="hot-left">
                    <img :src="item.cover" />
                    <span>{{index+1}}</span>
                  </div>
                  <div class="hot-right">
                    <div class="title" :title="item.name">{{item.name}}</div>
                    <div class="bottom"><span class="left">销量：{{item.soldNumber}}</span><span class="right"
                        v-show="item.minPrice">￥{{item.minPrice}}起</span></div>
                  </div>
                </li>
              </template>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'ticketDetail',
    data() {
      return {
        value: 4,
        detailShow: false,
        zhSort: -1, //综合排序 -1,不排序 0升序 1降序
        priceSort: -1, //价格排序 -1,不排序 0升序 1降序
        xlSort: -1, //销量排序 -1,不排序 0升序 1降序
        tjSort: -1, //推荐排序 -1,不排序 0升序 1降序
        dataList: [],
        topicList: [], //景区主题
        destinationList: [],
        levelList: ['5A', '4A', '3A', '2A', '1A'],
        destinationId: '',
        topicIds: [],
        level: '',
        hotTicketList: [],
        hotDataList: [] //热门景点
      }
    },
    created() {

    },
    mounted() {
      this.getData()
      this.getDestination()
      this.getTopic()
      this.getHotData()
      this.getHotTicketData()
    },
    computed: {
      searchList() {
        var arr = [];
        if (this.destinationId) {
          arr.push(this.destinationList.filter(item => item.id == this.destinationId)[0].name)
        }
        if (this.topicIds.length) {
          this.topicList.forEach(item => {
            if (this.topicIds.includes(item.id)) {
              arr.push(item.name)
            }
          })
        }
        if (this.level) {
          arr.push(this.level)
        }

        return arr;
      }
    },
    watch: {

    },
    methods: {
      async getHotTicketData() { //获取热卖门票
        const {
          code,
          data
        } = await getMallData('/ticket/listHot');
        if (code == 200) {
          this.hotTicketList = data
        }
      },
      async getHotData() { //获取热门景点
        const {
          code,
          data: {
            content
          }
        } = await getMallData('/scenicSpot/page', {
          isRecommend: true,
          pageIndex: 0,
          pageSize: 10
        });
        if (code == 200) {
          this.hotDataList = content
        }
      },

      clearData() {
        this.destinationId = ''
        this.topicIds = []
        this.level = ''
        this.getData()
      },
      hanbleTopicList(item) {
        if (this.topicIds.includes(item.id)) {
          this.topicIds = this.topicIds.filter(itm => item.id != itm)
        } else {
          this.topicIds.push(item.id)
        }
      },
      async getDestination() { //筛选--目的地
        const {
          code,
          data
        } = await getMallData('/destination/list');
        if (code == 200) {
          this.destinationList = data
        }
      },
      async getTopic() { //筛选--景区主题
        const {
          code,
          data
        } = await getMallData('/topic/list');
        if (code == 200) {
          this.topicList = data
          console.log('景点主题', this.topicList)
        }
      },
      changeSort(key) {
        if (this[key] > 1) {
          this[key] = -1;
        }
        if (key == 'priceSort') {
          this.xlSort = -1
        }
        if (key == 'xlSort') {
          this.priceSort = -1
        }

        this[key]++;
        if (this[key] <= 1) {
          this.getData()
        }

      },
      async getData() { //获取数据
        let searchObj = {}
        if (this.$route.query.search) searchObj['name'] = this.$route.query.search
        if (this.topicIds.join(',')) {
          searchObj['topicIds'] = this.topicIds.join(',')
        }
        if (this.destinationId) {
          searchObj['destinationId'] = this.destinationId
        }
        if (this.level) {
          searchObj['level'] = this.level
        }
        if (this.priceSort !== -1) {
          searchObj['sort'] = 'price'
          searchObj['direction'] = this.priceSort == 0 ? 'ASC' : 'DESC'
        }
        if (this.xlSort !== -1) {
          searchObj['sort'] = 'soldNumber'
          searchObj['direction'] = this.xlSort == 0 ? 'ASC' : 'DESC'
        }
        const {
          code,
          data
        } = await getMallData('/ticket/list', {
          ...searchObj
        });
        if (code == 200) {
          this.dataList = data
          console.log('门票列表', data);
          this.dataList.forEach(item => {
            item.ticketListVOS.forEach(itm => {
              itm['detailShow'] = false
            })
            item['moreTicket'] = false
          })
          this.$forceUpdate()
        }
      },
    }
  }
</script>

<style lang="less" scoped>
  .walfBox {
    width: 1200px;
    margin: 0 auto;
  }

  .overflow-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 350px;
  }

  .hotSpot {
    li {
      position: relative;
    }

    .tips {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 86px;
      line-height: 86px;
      text-indent: 35px;
      color: #FAF7F7;
      font-size: 27px;
      display: none;
      background-color: rgba(0, 0, 0, 0.5);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover .tips {
      display: block;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .container-center {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    color: #000;

    .container-box {
      background: #fff;
      padding: 20px;
      margin-top: 20px;

      .right {
        color: @mainColor;
        font-size: 17px;
        cursor: pointer;
        line-height: 40px;
      }
    }

    .container-center-left {
      width: 860px;

      .search-list {
        &>li {
          margin-bottom: 15px;
          display: flex;

          span {
            display: inline-block;
            width: 120px;
            text-align: right;
            font-size: 17px;
            line-height: 40px;
            font-weight: bold;
          }

          ul {
            flex: 1;
            display: inline-block;
            vertical-align: top;
          }
        }
      }

      .sort-list {
        background: #D9D9D9;
        padding: 10px 20px;
        margin: 36px 0 5px 0;

        li {
          display: inline-block;
          width: 150px;
          cursor: pointer;
          font-size: 18px;
          font-weight: bold;

          .arrow {
            width: 30px;
            height: 30px;
            display: inline-block;
            position: relative;
            vertical-align: bottom;

            i {
              position: absolute;
              color: #919191;

              &:nth-child(1) {
                top: 2px;
              }

              &:nth-child(2) {
                bottom: 2px;
              }

              &.activeTop {
                color: @mainColor;
              }
            }

          }

        }
      }

      .ticket-list {
        background: #fff;
        padding: 25px 15px 40px;
        margin-bottom: 26px;

        .ticket-list-top {
          display: flex;
          cursor: pointer;

          .ticket-list-left {
            width: 215px;

            img {
              width: 100%;
              height: 153px;
            }
          }

          .ticket-list-right {
            flex: 1;
            margin-left: 20px;
            position: relative;

            .title {
              span {
                font-size: 21px;
                font-weight: 600;
                margin-bottom: 19px;
                display: inline-block;
              }

              .el-rate {
                display: inline-block;
                vertical-align: super;
                margin-left: 20px;
              }
            }

            .tip {
              font-size: 16px;
              color: #707070;

              span:nth-child(1) {
                border-right: 1px solid #707070;
                padding-right: 6px;
                margin-right: 6px;
              }
            }

            .time {
              margin-top: 20px;

              i {
                width: 22px;
                height: 22px;
                display: inline-block;
                margin-right: 5px;
                background: url(../../../static/img/shijian.png) no-repeat;
                background-size: cover;
                vertical-align: middle;
              }
            }

            .address {
              margin-top: 10px;
              width: 390px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;

              i {
                width: 22px;
                height: 22px;
                display: inline-block;
                margin-right: 5px;
                background: url(../../../static/img/weizhi_l.png) no-repeat;
                background-size: cover;
                vertical-align: middle;
              }
            }

            .price {
              font-size: 35px;
              color: #F20E0E;
              position: absolute;
              top: 0;
              right: 0;

              span {
                font-size: 20px;
              }
            }
          }
        }

        .ticket-list-bottom {
          margin-top: 20px;

          li {
            padding: 14px;
            border-bottom: 1px solid #DFDFDF;
            position: relative;

            &:last-child {
              border: none;
            }

            .tip {
              margin-top: 10px;

              span {
                display: inline-block;
                padding: 2px 6px;
                font-size: 12px;
                margin-right: 10px;

                &:nth-child(1) {
                  border: 1px solid @mainColor;
                  color: @mainColor;
                }

                &:nth-child(2) {
                  border: 1px solid #0A84D5;
                  color: #0A84D5;
                }

                &:nth-child(3) {
                  border: 1px solid #EC4D4D;
                  color: #EC4D4D;
                }
              }
            }

            .tip-detail {
              background-color: #E6F3E1;
              padding: 15px;
              margin-top: 10px;

              .item {
                margin-bottom: 20px;
                font-size: 16px;
              }

              .title {
                color: #28A901;
                margin-bottom: 10px;
                font-weight: bold;

                &:before {
                  content: '';
                  display: inline-block;
                  width: 9px;
                  height: 28px;
                  background: @mainColor;
                  margin-right: 10px;
                  vertical-align: bottom;
                }
              }
            }

            .order {
              width: 100px;
              height: 30px;
              text-align: center;
              line-height: 30px;
              background: @mainColor;
              color: #fff;
              cursor: pointer;
              position: absolute;
              top: 20px;
              right: 20px;
            }
          }

          .more-btn {
            float: right;
            color: @mainColor;
            font-size: 15px;
            cursor: pointer;
            margin-right: 20px;
          }
        }
      }
    }

    .container-center-right {
      flex: 1;
      margin-left: 60px;

      ul {
        margin-top: 20px;
        background: #fff;
        padding: 10px;

        li {
          margin-bottom: 15px;
          font-size: 16px;
          display: flex;
          cursor: pointer;

          .hot-left {
            width: 196px;
            height: 132px;
            position: relative;

            img {
              width: 100%;
              height: 100%;
            }

            span {
              display: inline-block;
              width: 28px;
              height: 28px;
              background: #EC4D4D;
              color: #fff;
              position: absolute;
              top: 0;
              left: 0;
              text-align: center;
              line-height: 28px;
            }
          }

          .hot-right {
            flex: 1;
            margin-left: 20px;
            position: relative;

            .title {
              font-size: 16px;
              font-weight: 600;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 237px;
            }

            .bottom {
              position: absolute;
              left: 0;
              bottom: 10px;
              overflow: hidden;
              width: 100%;

              span:nth-child(2) {
                margin-right: 20px;
                color: #FFB507;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/shopping/ticket.vue